import { isValidUrl } from './validations';

export function isExternalUrlParam(entry: {
  link?: {
    href?: string;
  };
}): boolean {
  try {
    const entryLinkHref = entry?.link?.href;

    if (!isValidUrl(entryLinkHref)) return false;

    const linkHrefUrl = new URL(entryLinkHref);

    return (
      linkHrefUrl.searchParams.get('external_url') === 'true' ||
      linkHrefUrl.searchParams.get('external_type') === 'true'
    );
  } catch (e) {
    return false;
  }
}
